import { Incident } from '@silbo/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IncidentStepperLayout } from '../IncidentStepperLayout';
import { CommentStep } from '../steps/CommentStep';
import { DelayStep } from '../steps/DelayStep';
import { PositionStep } from '../steps/PositionStep';
import { UnassignmentStep } from '../steps/UnassignmentStep';

type InadequateFareTransportValue = Partial<
  Pick<Incident, 'adequateTransport' | 'delayInMinutes' | 'unassignmentRequested' | 'comment'>
>;

export function InadequateFareTransport({
  onBack,
  onComplete,
}: {
  onBack: () => void;
  onComplete: (value: InadequateFareTransportValue) => void;
}) {
  const { t } = useTranslation('patient-transport');

  const [value, setValue] = useState<InadequateFareTransportValue>({});

  const [activeStep, setActiveStep] = useState(0);

  const renderStep = () => {
    switch (activeStep) {
      case 0:
        return (
          <PositionStep
            value={value.adequateTransport}
            onChange={(adequateTransport) => setValue({ ...value, adequateTransport })}
          />
        );
      case 1:
        return (
          <DelayStep
            value={value.delayInMinutes}
            onChange={(delayInMinutes) => setValue({ ...value, delayInMinutes })}
          />
        );
      case 2:
        return (
          <UnassignmentStep
            value={value.unassignmentRequested}
            onChange={(unassignmentRequested) => setValue({ ...value, unassignmentRequested })}
          />
        );
      default:
        return (
          <CommentStep value={value.comment} onChange={(comment) => setValue({ ...value, comment })} incident={value} />
        );
    }
  };

  const isCurrentStepValid =
    activeStep === 0
      ? value.adequateTransport !== undefined
      : activeStep === 1
        ? value.delayInMinutes !== undefined
        : activeStep === 2
          ? value.unassignmentRequested !== undefined
          : true;

  return (
    <IncidentStepperLayout
      title={t('fareIncidents.INADEQUATE_FARE_TRANSPORT')}
      stepsLength={4}
      activeStep={activeStep}
      isCurrentStepValid={isCurrentStepValid}
      onPrevious={() => setActiveStep(activeStep - 1)}
      onNext={() => setActiveStep(activeStep + 1)}
      onBack={onBack}
      onComplete={() => onComplete(value)}
    >
      {renderStep()}
    </IncidentStepperLayout>
  );
}
